import { useEffect } from 'react';
import SEO from '../components/SEO';
import FAQ from '../components/FAQ';

const BranchOfficeDetails = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='bg-gray-50 text-gray-800 antialiased'>
      <SEO
        title='Branch Office Details - Gateway Financial Services Ltd.'
        description='Details of our branch offices.'
      />

      {/* BEGIN: Hero Section */}
      <section
        className='pwu-hero-bg text-white position-relative'
        style={{
          backgroundImage:
            "linear-gradient(rgba(12, 59, 68, 0.7), rgba(12, 59, 68, 0.7)), url('/images/banners/contactus-banner.webp')",
        }}
      >
        <div className='container position-relative' style={{ zIndex: 10 }}>
          <div className='row'>
            <div className='col-lg-8'>
              <h1 className='pwu-hero-title mb-4'>Branch Office</h1>
            </div>
          </div>
        </div>
      </section>
      {/* END: Hero Section */}
      <div style={{ backgroundColor: '#ebf3f5' }}>
        <main className='container py-5'>
          <section className='mb-5'>
            <div className='cu-table-container my-3 mt-4'>
              <table className='cu-table mb-0 text-left w-100'>
                <thead>
                  <tr>
                    <th style={{ width: '20%' }}>Branch Name</th>
                    <th style={{ width: '15%' }}>Registration Number</th>
                    <th style={{ width: '30%' }}>Branch Address</th>
                    <th style={{ width: '15%' }}>Contact No</th>
                    <th style={{ width: '20%' }}>Email Id</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Gateway Financial Services Limited (Dalhousie)</td>
                    <td>INZ000247937</td>
                    <td>
                      <i className='fa fa-map-marker' aria-hidden='true'></i>{' '}
                      23B N. S. Road, Dalhousie, Kolkata, 700001, West Bengal
                    </td>
                    <td>
                      <i className='fa fa-phone' aria-hidden='true'></i>{' '}
                      9831098322
                    </td>
                    <td>
                      <i className='fa fa-envelope' aria-hidden='true'></i>{' '}
                      igr@gatewayfin.in
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </main>
      </div>

      <FAQ />

      {/* BEGIN: App Download Section */}
      <section id='app-section'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-6 align-self-center'>
              <h3 data-aos='fade'>Download our Investment Fund App</h3>
              <p>Investing With Gateway Financial Services Limited</p>
              <a href='#download' className='lm-btn'>
                Download &amp; Explore More
              </a>
            </div>
            <div className='col-lg-6'>
              <img
                src='/images/download.avif'
                className='img-fluid'
                alt='Download App Preview'
              />
            </div>
          </div>
        </div>
      </section>
      {/* END: App Download Section */}
    </div>
  );
};

export default BranchOfficeDetails;
